import { Container } from '@volkswagen-onehub/components-core';
import React, { useContext } from 'react';
import ResultsHeadline from './ResultsHeadline';
import VehicleCard from './VehicleCard';
import { ResultsViewContainer } from '../styles/components';
import { ResultsViewContext } from '../utils/results-view-context';
import { VehicleData } from '../types';

interface ResultsVehicleInterface {
    secondaryVehicles?: VehicleData[]
    vehicles: VehicleData[],
    showHeadline?: boolean,
    background?: string,
    color?: string,
    headline?: JSX.Element
}

export default ({ vehicles, showHeadline = true, background, color, headline }: ResultsVehicleInterface) => {
    const { value: view } = useContext(ResultsViewContext);

    return vehicles && (
        <Container wrap="always" stretchContent>
            {showHeadline ? <ResultsHeadline background={background as string} color={color as string}>
                {headline}
            </ResultsHeadline> : null}

            <ResultsViewContainer view={view}>
                {
                    vehicles && vehicles.map((vehicle, i) => {
                      const key = `vehicle-${vehicle.id}-${i}`;
                        return (
                            <VehicleCard key={key} vehicle={vehicle} />
                        );
                    })
                }
            </ResultsViewContainer>
        </Container>
    )
}
